<script>
  import {addMessages, register, getLocaleFromNavigator, init, locale, locales, _} from 'svelte-i18n'	

  register('en', () => import("./../locales/en.json"))
  register('de', () => import("./../locales/de.json"))
  register('es', () => import("./../locales/es.json"))
  register('fr', () => import("./../locales/fr.json"))
  register('hi', () => import("./../locales/hi.json"))
  register('hr', () => import("./../locales/hr.json"))
  register('it', () => import("./../locales/it.json"))
  register('nl', () => import("./../locales/nl.json"))
  register('pl', () => import("./../locales/pl.json"))
  register('pt', () => import("./../locales/pt.json"))
  register('ru', () => import("./../locales/ru.json"))
  register('sc', () => import("./../locales/sc.json"))
  register('tr', () => import("./../locales/tr.json"))

  let availableLanguages = {
    en: 'English',
    de: 'Deutsch',
    es: 'Español',
    fr: 'Français',
    hi: 'हिंदी',
    hr: 'Hrvatski',
    it: 'Italiano',
    nl: 'Nederlands',
    pl: 'Polski',
    pt: 'Português',
    ru: 'Pусский',
    sc: 'Sardu',
    tr: 'Türkçe'
  }

  init({
    fallbackLocale: 'en',
    initialLocale: localStorage.getItem("language")
  })

  let selected = $locale

  function handleLocaleChange(event) {
    event.preventDefault();
    
    let new_locale = event.target.value
    locale.set(new_locale)
    localStorage.setItem("language", new_locale)
  }

</script>


<div class="locale-selector">
  <div class="select">
    <!-- svelte-ignore a11y-no-onchange -->
    <select bind:value={selected} on:change={handleLocaleChange}>
      {#each $locales as locale}
        <option value={locale} selected={locale===selected ? 'selected':''}>
          {availableLanguages[locale]}
        </option>
      {/each}
    </select>
  </div>
</div>


<style>
  .locale-selector {
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 0;
    visibility: hidden;
  }

  .select {
    margin: 0 1rem 1rem;
  }
</style>